import React, { useState, useEffect } from "react";
import Base from "../core/Base";
import { isAutheticated } from "../auth/helper";
import { Link } from "react-router-dom";
import { createCategory, getOneCategories, updateCate } from "./helper/adminapicall";

const UpdateCategory = ({ match }) => {
    const [name, setName] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const { user, token } = isAutheticated();

    const goBack = () => (
        <div className="mt-5">
            <Link className="btn btn-sm btn-success mb-3" to="/admin/dashboard">
                Admin Home
      </Link>
        </div>
    );

    const handleChange = event => {
        setError("");
        setName(event.target.value);
    };


    const preload = (categoryId) => {
        getOneCategories(categoryId)
            .then(
                (data) => {
                    console.log(data);
                    if (data.error) {
                        setError(data.error)
                    }
                    else {
                        setName(data.name)
                    }
                }
            )
    }

    useEffect(() => {
        preload(match.params.categoryId)
    }, [])

    const successMessage = () => {
        if (success) {
            return <h4 className="text-success">Category created successfully</h4>;
        }
    };

    const warningMessage = () => {
        if (error) {
            return <h4 className="text-success">Failed to create category</h4>;
        }
    };




    const onSubmit = event => {
        event.preventDefault();
        setError("");
        setSuccess(false);

        //backend request fired
        console.log(user._id);
        console.log(match.params.categoryId);
        updateCate(match.params.categoryId, user._id, token, name).then(
            data => {
                if (data.error) {
                    setError(true);
                    console.log(data.error);
                } else {
                    setError("");
                    setSuccess(true);
                    setName("");
                }
            });
    };


    const myCategoryForm = () => (
        <form>
            <div className="form-group">
                <p className="lead">Enter the category</p>
                <input
                    type="text"
                    className="form-control my-3"
                    onChange={handleChange}
                    value={name}
                    autoFocus
                    required
                    placeholder={name}
                />
                <p>{name}</p>
                <button onClick={onSubmit} className="btn btn-outline-info">
                    Update Category
        </button>
            </div>
        </form>
    );

    return (
        <Base
            title="Create a category here"
            description="Add a new category for new tshirts"
            className="container bg-info p-4"
        >
            <div className="row bg-white rounded">
                <div className="col-md-8 offset-md-2">
                    {successMessage()}
                    {warningMessage()}
                    {myCategoryForm()}
                    {goBack()}
                </div>
            </div>
        </Base>
    );
};

export default UpdateCategory;
